import { Module } from 'vuex'
import { RootState } from '@/store/types'
import Locale from '@/modules/i18n/model/Locale'
import WorldLocale from '@/modules/i18n/model/WorldLocale'
import Message from '@/modules/i18n/model/Message'
import MessagePagination from '@/modules/i18n/model/MessagePagination'
import actions from '@/modules/i18n/store/actions'
import mutations, { MessageListModes } from '@/modules/i18n/store/mutations'
import getters from '@/modules/i18n/store/getters'
import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Almacena el estado del componente que muestra la lista de mensajes
 * para un localismo, no confundir con la lista en si.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
interface MessageListState {
    selectedLocale: string,
    selectedMessage: Message | null
    mode: MessageListModes,
    pagination: MessagePagination,
    currentPage: number,
    recordsPerPage: number,
    paginationFilters: KeyValuePair,
}

interface I18nState {
    locales: Locale[],
    localeListFullyLoaded: boolean
    worldLocales: WorldLocale[],
    messageList: MessageListState
    defaultLocale: Locale | null
}

const vuexModule: Module<I18nState, RootState> = {
    namespaced: true,
    actions,
    mutations,
    getters,
    state: {
        defaultLocale: null,
        locales: [],
        localeListFullyLoaded: false,
        worldLocales: [],
        messageList: {
            selectedLocale: '',
            selectedMessage: new Message(),
            mode: MessageListModes.None,
            pagination: new MessagePagination(),
            currentPage: 1,
            recordsPerPage: 20,
            paginationFilters:  {},
        },
    },
}

export {
    I18nState,
    vuexModule as default,
}
